import PresentationItem from "./PresentationItem";
import { ApplicationWithId } from "../../../interfaces/IApplications";
import { Box, Typography } from "@mui/material";
import { CategoryWithId } from "../../../interfaces/ICategories";
import { memo } from "react";

interface PresentationsListProps {
  presentations: any[];
  application: ApplicationWithId;
  category: CategoryWithId;
  onEditPresentation: (presentation: any) => void;
  onDeletePresentation: (presentation: any) => void;
}

function PresentationsList({
  presentations,
  application,
  category,
  onEditPresentation,
  onDeletePresentation,
}: PresentationsListProps) {
  if (presentations.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="body2" sx={{ color: "#6c6c6c" }}>
          Brak prezentacji w tej kategorii
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 0 }}>
      {presentations.map((presentation, index) => (
        <PresentationItem
          key={presentation.id || `temp-${index}-${presentation.name}`}
          presentation={presentation}
          application={application}
          category={category}
          onEditPresentation={onEditPresentation}
          onDeletePresentation={onDeletePresentation}
          isLast={index === presentations.length - 1}
        />
      ))}
    </Box>
  );
}

// Memoized component to prevent unnecessary re-renders
export default memo(PresentationsList, (prevProps, nextProps) => {
  return (
    prevProps.presentations === nextProps.presentations &&
    prevProps.application === nextProps.application &&
    prevProps.category.id === nextProps.category.id
  );
});
